import { Injectable } from '@angular/core';
import { TransitionService, Transition } from '@uirouter/angular';
import { ShelvableStateDeclaration } from '../states'
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';

export type SearchConfig = {
    visible:() => Observable<boolean>,
    rightButtonType?:'add-single' | 'add-multi'
}

export type SearchConfigInstance = {
    visible:Observable<boolean>,
    rightButtonType?:'add-single' | 'add-multi'
}

@Injectable()
export class SearchConfigService {
    config:BehaviorSubject<SearchConfigInstance> = new BehaviorSubject<SearchConfigInstance>({visible: Observable.of(false)});

    constructor(transitionService:TransitionService) {
        transitionService.onSuccess({}, (transition:Transition) => {
            var state = <ShelvableStateDeclaration> transition.targetState().state();
            this.config.next({rightButtonType: state.searchConfig.rightButtonType, visible: state.searchConfig.visible()});
        });
    }
}


// WEBPACK FOOTER //
// ./web/static/services/SearchConfigService.ts